//引入接口文档
import req from '@/utils/req.js'

//后台查看患者一周的体重bmi信息
export function getBmiWeightList(params) {
  return req.post("/admin/patient-bmi/getPatientBmiByPatientOrderByStartDate",params);
}

// //健康基础测评列表查询
// export function getLeftList(params) {
//   return req.post("/admin/health-tool-test/list",params);
// }

// //健康基础测评详情
// export function getDetail(params) {
//   return req.get(`/admin/health-tool-test/${params.id}`);
// }

// //健康基础测评删除
// export function deleteType(params) {
//   return req.delete(`/admin/health-tool-test/${params.id}`);
// }

//后台查看患者所有科研数据
export function getAdminPatientDataForAdmin(params) {
  return req.post("/doctor/research-data-fromhcn/getAdminPatientDataForAdmin",params);
}

